export { default } from "./UserPage";



// WEBPACK FOOTER //
// ./src/screens/User/index.ts